export default {
  selectedControls: (state, getters, rootState, rootGetters) => {
    let items = state.items;
    items = items.filter((item) => {
      return state.selectedType && item.type === state.selectedType.key;
    });
    return items;
  },
};
